export const defaultTranslation = {
	translation: {
		exposure: {
			singular: {
				upper: 'Exposure',
				lower: 'exposure',
			},
			plural: {
				upper: '$t(exposure.singular.upper)s',
				lower: '$t(exposure.singular.lower)s',
			},
		},
		peril: {
			singular: {
				upper: 'Peril',
				lower: 'peril',
			},
			plural: {
				upper: '$t(peril.singular.upper)s',
				lower: '$t(peril.singular.lower)s',
			},
		},
		endorsement: {
			singular: {
				upper: 'Endorsement',
				lower: 'endorsement',
			},
			plural: {
				upper: '$t(endorsement.singular.upper)s',
				lower: '$t(endorsement.singular.lower)s',
			},
		},
		renewal: {
			singular: {
				upper: 'Renewal',
				lower: 'renewal',
			},
			plural: {
				upper: '$t(renewal.singular.upper)s',
				lower: '$t(renewal.singular.lower)s',
			},
		},
	},
};
